import { render, staticRenderFns } from "./releaseSuccess.vue?vue&type=template&id=3abe47c6&scoped=true"
import script from "./releaseSuccess.vue?vue&type=script&lang=js"
export * from "./releaseSuccess.vue?vue&type=script&lang=js"
import style0 from "./releaseSuccess.vue?vue&type=style&index=0&id=3abe47c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abe47c6",
  null
  
)

export default component.exports